import { Component, ElementRef, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { NotificationService } from 'src/app/Service/notification.service';
import { OtherService } from 'src/app/Service/other.service';
import { registerables } from 'chart.js';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';
import axios from 'src/app/Service/axios';

@Component({
  selector: 'app-fleetdiag-dashboard',
  templateUrl: './fleetdiag-dashboard.component.html',
  styleUrls: ['./fleetdiag-dashboard.component.css'],
})

export class FleetdiagDashboardComponent implements OnInit {
  obj: any;
  ctx1: any;
  label: Array<any> = [];
  datachart: Array<any> = [];

  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  searchForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('ID')!),
    ),
    strSession: new FormControl(
      this.gurdService.decrypt(window.localStorage.getItem('Session')!),
    ),
    strPID: new FormControl(),
  });

  constructor(
    private el: ElementRef,
    private _tooltip: NotificationService,
    private router: Router,
    public _otherService: OtherService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private gurdService: GurdServiceService,
  ) {
    Chart.register(...registerables);

    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    const id = this.route.snapshot.params['slug'];
    this.searchForm.controls['strPID'].setValue(id);
    this.initChart();
  }

  async initChart() {
    this._otherService.Showspinner();

    let res = JSON.parse(
      (
        await axios.post(
          'FleetDiag_OBD2_Code_DashboardChart',
          this._otherService.stringNumberToNumber(this.searchForm.value),
        )
      ).data.toString(),
    );

    this._otherService.nonespinner();

    if (res.ISSessionExpired == true) {
      this._otherService.removeLocalStorage();

      this.router.navigate(['login'], { queryParams: { error: '1xxA4' } });

      return;
    }

    if (res.iResult == 0) return this._tooltip.showError(res.strError);

    this.drawChart(res);
  }

  drawChart(resParse: any) {
    this.obj = resParse;

    this.label = [];
    this.datachart = [];

    this.obj.forEach((element: any) => {
      this.label.push(element.X);
      this.datachart.push(element.Y);
    });

    const ctx = document.getElementById('myChart') as any;

    if (this.ctx1) {
      this.ctx1.destroy();
    }

    this.ctx1 = new Chart(ctx, {
      type: 'line',

      data: {
        labels: this.label,
        datasets: [
          {
            data: this.datachart,
            borderColor: this.CHART_COLORS.blue,
            backgroundColor: 'rgba(29, 179, 214, 0.15)',
            fill: true,
            tension: 0.4,

            pointBackgroundColor: this.CHART_COLORS.blue,
            pointBorderColor: '#ffffff',
            pointRadius: 4,
            pointHoverRadius: 6,
          },
        ],
      },

      options: {
        responsive: true,

        interaction: {
          mode: 'nearest',
          intersect: false,
        },

        plugins: {
          legend: {
            display: false,
          },

          tooltip: {
            enabled: true,

            backgroundColor: '#ffffff',
            borderColor: this.CHART_COLORS.blue,
            borderWidth: 1,

            titleColor: '#333333',
            bodyColor: '#555555',

            titleFont: {
              family: 'bYekan',
              size: 13,
            },

            bodyFont: {
              family: 'bYekan',
              size: 12,
            },

            padding: 10,
            displayColors: false,

            callbacks: {
              label: (context) => {
                return `مقدار: ${context.parsed.y}`;
              },
            },
          },

          zoom: {
            zoom: {
              wheel: { enabled: true },
              pinch: { enabled: true },
              mode: 'x',
            },
          },
        },

        scales: {
          x: {
            ticks: {
              color: '#666666',
              font: {
                family: 'bYekan',
                size: 12,
              },
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderColor: 'rgba(0, 0, 0, 0.2)',
              borderWidth: 1,
            },
          },

          y: {
            ticks: {
              color: '#666666',
              font: {
                family: 'bYekan',
                size: 12,
              },
            },
            grid: {
              color: 'rgba(0, 0, 0, 0.05)',
              borderColor: 'rgba(0, 0, 0, 0.2)',
              borderWidth: 1,
            },
          },
        },
      },
    });
  }
}
